import { render, staticRenderFns } from "./CuestionarioLactanciaParasitosis.vue?vue&type=template&id=6b95ca8e&"
import script from "./CuestionarioLactanciaParasitosis.vue?vue&type=script&lang=js&"
export * from "./CuestionarioLactanciaParasitosis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports